<template>
  <div>
    <template>
      <v-card>
        <v-card-title>
          <span class='headline fontcolor'>{{ formTitle }}</span>
        </v-card-title>
        <v-card class='pl-7 pr-6 pt-5 pb-5'>
          <v-form ref='form' v-model='valid' lazy-validation>
            <v-row>
              <v-col>
                <v-text-field
                  v-model='editedItem.name'
                  :rules='publisherRules'
                  :maxlength='maxLength'
                  hint='Please enter publisher name. Only letters (A-Z, a-z), space and period, hyphen, underscore, copyright, registered, trademark is allowed.'
                  label='Publisher name*'
                  validate-on-blur counter="255"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model='editedItem.acronym'
                  :maxlength='maxAcronymLength'
                  :rules='acronymRules'
                  hint='Please enter acronym. Only letters (A-Z, a-z), numbers, space, period, hyphen and underscore, registration mark is allowed. Maximum length 10 characters.'
                  label='Acronym*'
                  validate-on-blur
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model='editedItem.status'
                  :items='statusItems'
                  label='Status*'
                  :rules='statusRules'
                  item-text='statusText'
                  item-value='statusVal'
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols='12' sm='4' md='6' lg='12'>
                <v-file-input
                  accept='image/png, image/jpg'
                  label='Upload Logo'
                  hint='Allowed file formats are .png and .jpg. Recommended size is 250*100px.'
                  v-model='chosenFile'
                  :rules='[IsValidImage]'
                  @change='importLogoFile'
                ></v-file-input>
                <v-col v-if="editedItem.logoUrl">
                <v-img
                  :src='logoImageExist ? editedItem.logoUrl : undefined'
                  alt='Logo'
                  aspect-ratio='1'
                  max-width='50'
                  max-height='50'
                ></v-img>
                <span
                  style='max-width: 80px;'
                  class='caption d-inline-block text-truncate font-weight-regular'
                >{{logoName}}</span>
                </v-col>
              </v-col>
            </v-row>
             <v-row>
              <v-col>
                <v-text-field
                  v-model='editedItem.createdBy'
                  label='Created By'
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
             <v-row>
              <v-col>
                <v-text-field
                  v-model='editedItem.createdDate'
                  label='Created Date'
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
             <v-row>
              <v-col v-if="editedItem.createdDate !== editedItem.modifiedDate">
                <v-text-field
                  v-model='editedItem.modifiedBy'
                  disabled
                  label='Modified By'
                ></v-text-field>
              </v-col>
            </v-row>
             <v-row>
              <v-col v-if="editedItem.createdDate !== editedItem.modifiedDate">
                <v-text-field
                  v-model='editedItem.modifiedDate'
                  disabled
                  label='Modified Date*'
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-actions>
              <small color='primary'>*indicates required fields</small>
              <v-spacer></v-spacer>
              <v-btn outlined dark color='red' @click='closeDialog'>
                <v-icon dark>mdi-close</v-icon>Cancel
              </v-btn>
              <v-btn :loading='btnLoader' outlined class='fontcolor' @click='save'>
                <v-icon dark>mdi-check</v-icon>Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-card>
    </template>
 </div>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  data: () => ({
    valid: false,
    maxLength: 250,
    maxAcronymLength: 10,
    editedIndex: -1,
    chosenFile: undefined,
    selectedPublisher: {},
    formTitle: CONSTANTS.EDIT_PUBLISHER,
    editedItem: {
      name: '',
      acronym: '',
      statusText: '',
      status: null,
      logo: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: '',
      logoUrl: ''
    },
    defaultForm: {
      name: '',
      acronym: '',
      status: '',
      logo: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: ''
    },
    btnLoader: false,
    statusItems: [
      { statusText: 'Inactive', statusVal: 1 },
      { statusText: 'Published', statusVal: 2 }
    ],
    publisherRules: [
      v => !!v || 'Publisher name is required.',
      v =>
        /^[a-zA-Z0-9 ._©®™-]+$/.test(v) ||
        'Invalid input. Only characters (A-Z, a-z), period, space, underscore, copyright, registered, trademark is allowed!'
    ],
    acronymRules: [
      v => !!v || 'Acronym is required.',
      v =>
        /^[a-zA-Z0-9 ._®-]+$/.test(v) ||
        'Invalid input. Only characters (A-Z, a-z), number, period, space, hyphen, underscore, registered mark is allowed!'
    ],
    statusRules: [v => !!v || 'Status is required.'],
    logoRules: [
      v => {
        const val = v.name
        if (
          val &&
          val !== undefined &&
          val !== null &&
          val.slice(val.lastIndexOf('.') + 1) !== 'png' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'jpg' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'PNG' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'JPG' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'jpeg' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'JPEG'
        ) {
          return 'Invalid Input. Excepted file formats are .jpg and .png'
        } else {
          return false
        }
      }
    ]
  }),
  props: {
    userId: {
      type: Number,
      required: true
    },
    publisher: {
      type: Object
    },
    selectedEditedIndex: {
      type: Number,
      required: true
    }
  },
  mounted () {
    this.selectedPublisher = this.publisher
    this.editItem(this.selectedPublisher)
  },
  computed: {
    logoName () {
      const logo = this.editedItem.logoUrl
      let logoName = this.$globalStates.fetchImgNameFromImgURL(logo)
      return logoName
    }
  },
  methods: {
    closeDialog () {
      this.editedItem = Object.assign({}, this.defaultForm)
      this.editedIndex = -1
      this.btnLoader = false
      this.$refs.form.resetValidation()
      this.dialog = false
      this.$emit('resetEditDialog', this.dialog)
    },
    editItem (publisher) {
      this.editedIndex = this.selectedEditedIndex
      this.editedItem = Object.assign({}, publisher)
      this.dialog = true
      this.$emit('resetDialog', this.dialog)
    },
    logoImageExist () {
      let img = this.editedItem.logoUrl
      if (img === undefined) { return false }
      if (img.includes('png') || img.includes('PNG') ||
      img.includes('jpg') || img.includes('JPG') ||
      img.includes('jpeg') || img.includes('JPEG')) {
        return true
      } else {
        this.editedItem.logoUrl = undefined
        return false
      }
    },
    importLogoFile (e) {
      if (!this.chosenFile) {
        this.chosenFile = undefined
      }
      this.chosenFile = e
      return this.chosenFile
    },
    save () {
      if (this.$refs.form.validate()) {
        this.btnLoader = true
        Object.assign(this.editedItem)
        let editPublisherData = this.editedItem
        let editedData = new FormData()
        editedData.append('logo', this.chosenFile)
        editedData.append('name', editPublisherData.name)
        editedData.append('status', editPublisherData.status)
        editedData.append('acronym', editPublisherData.acronym)
        editedData.append('userId', this.userId)
        editedData.append('id', editPublisherData.id)
        new Promise((resolve, reject) => {
          this.$store.dispatch('PublisherModule/editPublisherItem', {
            resolve,
            reject,
            editedData
          })
        })
          .then(responseData => {
            this.$globalStates.notification.text = responseData.responseMessage
            this.btnLoader = false
            this.$globalStates.notification.init_notifications = true
            this.$globalStates.notification.type = 'green'
            this.closeDialog()
          })
          .catch(response => {
            this.$globalStates.notification.text = response.responseMessage
            this.btnLoader = false
            this.$globalStates.notification.init_notifications = true
            this.$globalStates.notification.type = 'red'
          })
      }
    },
    IsValidImage (v) {
      if (v) {
        const val = v.name
        if (
          val &&
          val !== undefined &&
          val !== null &&
          val.slice(val.lastIndexOf('.') + 1) !== 'png' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'jpg' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'PNG' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'JPG' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'jpeg' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'JPEG'
        ) {
          return 'Invalid Input. Excepted file formats are .jpg and .png'
        } else {
          return true
        }
      } else {
        return true
      }
    }
  }
}
</script>
